import { getFlatTourBookingInfo } from './getFlatTourBookingInfo';
import { IAppState } from '../../common/state';

export function getFlatTourBookingStatusDescription(state: IAppState): string {
  const flatTourBookingInfo = getFlatTourBookingInfo(state);

  return flatTourBookingInfo?.orderStatus?.description || 'Вы записались на просмотр квартиры в данном ЖК';
}
